import React, {Fragment, useRef} from "react";
import {isMobile, isTablet} from "react-device-detect"
import {
    Table,
    Descriptions,
    Card,
    Pagination,
    Row,
    Col,
    Typography,
    Divider,
    Spin,
    Empty,
    Menu,
    Space,
    Dropdown, Checkbox, Button, Collapse, Badge, Avatar, Switch
} from "antd";
import {
    FilterOutlined,
    FilterTwoTone,
    FilterFilled,
    CaretUpFilled,
    CaretDownFilled,
    KeyOutlined
} from "@ant-design/icons";
import {connect} from "react-redux";
import {AppLayout} from "../layouts/AppLayout";
import moment from "moment/moment";
import {getConfig} from "./permissions/functions";
import AccessAttrAvatars from "./custom-fields/AccessAttrAvatars";
import ModalAcl from "../modals/ModalAcl";

const {Text, Title} = Typography

class ResponsiveTable extends React.Component {

    state = {
        filters: {},
        sorter: {},
        selected: []
    }

    getProps(){
        let props={...this.props}

        if(props.pagination){
            props.pagination={...props.pagination,pageSizeOptions:[10, 20, 50, 100,100*1000],showSizeChanger:true}
        }

        //console.log("getProps",props)
        return props
    }

    componentDidMount() {
        this.onSelection()

        let defaultFilters={}
        for(let c of this.props.columns){
            if(Array.isArray(c?.defaultFilteredValue) && c.defaultFilteredValue.length>0 && c.dataIndex){
                defaultFilters[c.dataIndex]=c.defaultFilteredValue
            }
        }

        console.log("defaultFilters",defaultFilters)
        this.setState({filters:defaultFilters})
    }

    onSelection() {
        const keys = this.state.selected.map(i => i.key)
        const rows = this.state.selected.map(i => i.row)
        if (this.props.rowSelection?.onChange) {
            this.props.rowSelection.onChange(keys, rows)
        }
    }

    onChangePage(page) {
        var pagination = {...this.getProps().pagination}
        pagination.current = page
        this.props.onChange(pagination, this.state.filters, this.state.sorter)
        this.setState({selected: []}, () => this.onSelection())
        window.scrollTo({top: 0, left: 0, behavior: "smooth"});
    }

    onChangeFilters(filters) {
        var newFilters = {...this.state.filters, ...filters}

        var finalFilter = {}
        Object.keys(newFilters).map((k) => {
            if (Array.isArray(newFilters[k]) && newFilters[k].length > 0) {
                finalFilter[k] = newFilters[k]
            }
        })

        if (JSON.stringify(finalFilter) != JSON.stringify(this.state.filters)) {
            this.setState({filters: finalFilter}, () => {
                this.props.onChange(this.getProps().pagination, this.state.filters, this.state.sorter)
                this.setState({selected: []}, () => this.onSelection())
            })
        }
    }

    onChangeSorter(sorter) {

        if (JSON.stringify(sorter) != JSON.stringify(this.state.sorter)) {
            this.setState({sorter: sorter}, () => {
                this.props.onChange(this.getProps().pagination, this.state.filters, this.state.sorter)
                this.setState({selected: []}, () => this.onSelection())
            })
        }
    }

    render() {
        //console.log(isTablet,isMobile,!isMobile && !isTablet)

        const org = this.props.org

        let columns = [...this.props.columns]

        //console.log(columns,this.props.columns)

        let props=this.getProps()



        const isAttrSystem = getConfig("AttrSystem", "CONFIG")

        if (isAttrSystem && this.props.withAccess)
        {
            columns.push({
                key: "access",
                title: 'Crée par',
                dataIndex: "access",
                align: "center",
                filters: org.accessList.map(i => {
                    return {text: i.prenom + " " + i.nom, value: i.id}
                }),
                render: (col, row) => {
                    let rowAccess = row.access
                    if (this.props.accessKey) {
                        rowAccess = this.props.accessKey(row)
                    }

                    if (!rowAccess?.id) {
                        return "-"
                    }

                    let bgColor = "#000"
                    let shortName = rowAccess?.prenom.slice(0, 3).toUpperCase()

                    const _access = org.accessList.find(i => i.id === rowAccess.id)
                    if (_access && _access.shortName) {
                        shortName = _access.shortName
                    }
                    if (_access && _access.color) {
                        bgColor = _access.color
                    }

                    return (
                        <Avatar size={isMobile ? "small" : "default"}
                                style={{backgroundColor: bgColor, color: "#FFF"}}>{shortName}</Avatar>
                    )
                }
            })


            columns.push({
                key: "accessAttr",
                title: 'Attr. à',
                dataIndex: "accessAttr",
                align: "center",
                filters: org.accessList.map(i => {
                    return {text: i.prenom + " " + i.nom, value: i.id}
                }),
                render: (col, row) => {
                    let rowAccess = row.access
                    if (this.props.accessKey) {
                        rowAccess = this.props.accessKey(row)
                    }

                    let rowAccessAttr = row.accessAttr
                    if (this.props.accessAttrKey) {
                        rowAccessAttr = this.props.accessAttrKey(row)
                    }

                    if (rowAccess && (!rowAccessAttr || !Array.isArray(rowAccessAttr))) {
                        return "-"
                    }

                    let _accessExtra={}
                    if(this.props.accessExtra){
                        _accessExtra=this.props.accessExtra(row) || {}
                    }

                    return (
                        <AccessAttrAvatars
                            id={row.id}
                            accessAttr={rowAccessAttr || []}
                            accessType={this.props.accessType}
                            accessExtra={_accessExtra}
                            onChange={() => {
                                this.props.onChange(this.getProps().pagination, this.state.filters, this.state.sorter)
                            }}
                        />
                    )
                }
            })
        }


        if (this.props.access?.type==="ADMIN" && (this.props.org.accessList || []).filter(i=>i.type!=="ADMIN").length>0 && this.props.aclType)
        {
            columns.push({
                key: "acl",
                title: 'Permissions',
                align: "center",
                render: (col, row) => {
                    return (
                        <AclButton
                            aclType={this.props.aclType}
                            row={row}
                            onChange={() => {
                                this.props.onChange(this.getProps().pagination, this.state.filters, this.state.sorter)
                            }}
                        />
                    )
                }
            })
        }


        if (!isMobile || isTablet) {
            return (
                <Table {...props} columns={columns}/>
            )
        }


        var cardStyle = {marginTop: 20}
        var type = null
        if (this.props.embeded) {
            //cardStyle.backgroundColor="#1D2730"
            type = "inner"
        }

        var filtersOpt = this.props.columns.filter(i => i.filters && i.onFilter == undefined)
        var sorterOpt = this.props.columns.filter(i => i.sorter == true)

        var dataSource = this.props.dataSource || []

        dataSource.filter(i=>i).map((row, rindex)=>{
            var key = null
            if (this.props.rowKey) {
                key = this.props.rowKey(row,rindex)
            } else {
                key = row.id
            }
            row.key=key

            return row
        })

        return (
            <div>


                {filtersOpt.length > 0 && (
                    <Collapse style={{marginTop: 15}}>
                        <Collapse.Panel header={"Filtrer"} extra={<Badge style={{backgroundColor: 'rgb(62, 121, 247)'}}
                                                                         count={Object.keys(this.state.filters).length}/>}>
                            <Row style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                {
                                    filtersOpt.map((col, i) => <FilterButton col={col} state={this.state.filters}
                                                                             onChange={(filters) => this.onChangeFilters(filters)}/>)
                                }
                            </Row>
                        </Collapse.Panel>
                    </Collapse>
                )}

                {sorterOpt.length > 0 && (
                    <Collapse style={{marginTop: 15}}>
                        <Collapse.Panel header={"Trier"} extra={<Badge
                            status={Object.keys(this.state.sorter).length > 0 ? "processing" : "default"}/>}>
                            <Row style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                                {
                                    sorterOpt.map((col, i) => <SorterButton col={col} sorter={this.state.sorter}
                                                                            onChange={(sorter) => this.onChangeSorter(sorter)}/>)
                                }
                            </Row>
                        </Collapse.Panel>
                    </Collapse>
                )}


                {props.pagination && (
                    <div style={{display: "flex", justifyContent: "center", alignItems: "center", marginTop: 15}}>
                        <Pagination {...props.pagination}
                                    onChange={(page, pageSize) => this.onChangePage(page, pageSize)}/>
                    </div>
                )}


                {props.rowSelection && dataSource.length > 0 && (
                    <div style={{marginTop:20}}>
                       <Switch
                           checked={this.state.selected.length===dataSource.length}
                           onChange={(_bool)=>{
                               let _selected=[]
                               if(_bool){
                                   _selected=dataSource.map(i=>({row:i,key:i.key}))
                               }
                               this.setState({selected: _selected}, () => this.onSelection())
                           }}
                        checkedChildren={"Tous sélectionnés"}
                        unCheckedChildren={"Tous désélectionnés"}
                       />
                    </div>
                )}

                <Spin spinning={this.props.loading} style={{marginTop: 20, minHeight: 200}}>
                    {(dataSource.length == 0 && !this.props.loading) ? <div style={{marginTop: 50}}><Empty/></div> :

                        dataSource.map((row, rindex) => {
                            if (!row) {
                                return null
                            }

                            var key = null
                            if (this.props.rowKey) {
                                key = this.props.rowKey(row,rindex)
                            } else {
                                key = row.id
                            }


                            var action = null
                            if (this.props.columns.find(i => i.action)) {
                                action = this.props.columns.find(i => i.action)
                            }

                            var title = null
                            if (this.props.rowSelection) {
                                title = (
                                    <Checkbox checked={this.state.selected.some(i => i.key == key)} onChange={(e) => {
                                        var selected = [...this.state.selected]
                                        if (e.target.checked) {
                                            selected.push({key: key, row: row})
                                        } else {
                                            selected.splice(selected.findIndex(i => i.key == key), 1)
                                        }
                                        this.setState({selected: selected}, () => this.onSelection())
                                    }}/>)
                            }

                            return (
                                <Card type={type} title={title} bodyStyle={{padding: 0, overflow: "hidden"}}
                                      style={cardStyle} key={key} extra={action ? action.render(null, row) : null}>
                                    <Descriptions style={{padding: 20}}>
                                        {columns.map((column, cindex) => {
                                            if (column.action) {
                                                return null
                                            }

                                            var col = null
                                            if (row[column.dataIndex] !== undefined) {
                                                col = row[column.dataIndex]
                                            }

                                            return (
                                                <Descriptions.Item key={cindex}
                                                                   label={column.title}><Row>{column.render ? column.render(col, row) : col}</Row></Descriptions.Item>
                                            )
                                        })}
                                    </Descriptions>
                                    {this.props.expandable && (
                                        <Collapse>
                                            <Collapse.Panel header={"Voir Plus"}>
                                                {this.props.expandable.expandedRowRender(row, rindex)}
                                            </Collapse.Panel>
                                        </Collapse>
                                    )}
                                </Card>
                            )

                        })

                    }

                    {props.pagination && (
                        <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                            <Pagination {...props.pagination}
                                        onChange={(page, pageSize) => this.onChangePage(page, pageSize)}/>
                        </div>
                    )}
                </Spin>
            </div>
        )


    }
}


class SorterButton extends React.Component {
    onChange(order) {
        var object = {}
        if (order !== 0) {
            object["field"] = this.props.col.dataIndex
            object["order"] = order == 1 ? "ascend" : "descend"
        }
        this.props.onChange(object)
        this.setState({open: false})
    }

    formatOrder(sorter) {
        if (!sorter.order || this.props.col.dataIndex != sorter.field) {
            return 0
        }

        if (sorter.order == "ascend") {
            return 1
        }

        return -1
    }

    render() {
        if (!this.props.col.dataIndex) {
            return null
        }

        const sorter = this.props.sorter
        const order = this.formatOrder(sorter)

        return (
            <div style={{marginRight: 5, marginTop: 10}}>
                <Button style={{padding: "0 10px"}} type="ghost" onClick={() => {
                    var nextOrder = 0
                    switch (order) {
                        case 0:
                            nextOrder = 1
                            break;
                        case 1:
                            nextOrder = -1
                            break;
                        case -1:
                            nextOrder = 0
                            break;
                    }
                    this.onChange(nextOrder)
                }}>
                    <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                        <span style={{marginRight: 10}}>{this.props.col.title}</span>
                        <div style={{display: "flex", flexDirection: "column"}}>
                            <CaretUpFilled style={{color: order != 1 ? "#DDD" : "rgb(62, 121, 247)"}}/>
                            <CaretDownFilled style={{color: order != -1 ? "#DDD" : "rgb(62, 121, 247)"}}/>
                        </div>
                    </div>
                </Button>
            </div>
        )
    }

}

class FilterButton extends React.Component {
    constructor(props) {
        super(props);

        var filters = Object.keys(props.state).find(i => i == props.col.dataIndex) || []
        this.state = {
            open: false,
            filters: filters
        }
    }

    componentDidMount() {
        document.addEventListener("click", this.onClickOver)
    }

    onClickOver = () => {
        this.setState({open: false})
    }

    componentWillUnmount() {
        document.removeEventListener("click", this.onClickOver)
    }

    onChange() {
        var object = {}
        object[this.props.col.dataIndex] = this.state.filters
        this.props.onChange(object)
        this.setState({open: false})
    }

    render() {
        if (!this.props.col.dataIndex) {
            return null
        }

        return (
            <div onClick={(e) => e.stopPropagation()} style={{marginRight: 5, marginTop: 10}}>
                <Dropdown overlay={
                    <Card style={{border: "1px solid grey"}}>
                        <div style={{maxHeight: 200, overflowY: "auto", padding: "0 15px"}}>
                            {this.props.col.filters.map((item, index) => {
                                var checked = false

                                if (this.state.filters.includes(item.value)) {
                                    checked = true
                                }

                                return (
                                    <div key={index} style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        padding: "10px 0",
                                        borderBottom: index == this.props.col.filters.length - 1 ? "none" : "1px solid grey"
                                    }}>
                                        <Checkbox checked={checked} onChange={(v) => {
                                            var newFilters = [...this.state.filters]

                                            if (checked) {
                                                newFilters.splice(newFilters.indexOf(item.value), 1)
                                            } else {
                                                newFilters.push(item.value)
                                            }
                                            this.setState({filters: newFilters})
                                        }}/>
                                        <Text style={{marginLeft: 10}}>{item.text}</Text>
                                    </div>
                                )
                            })}
                        </div>

                        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                            <Button type="link"
                                    onClick={() => this.setState({filters: []}, () => this.onChange())}>Réinitialiser</Button>
                            <Button type="primary" onClick={() => this.onChange()}>OK</Button>
                        </div>
                    </Card>
                } open={this.state.open}>
                    <Button style={{padding: "0 10px"}} type="dashed"
                            onClick={() => this.setState({open: !this.state.open})}>
                        {this.props.col.title} <FilterFilled
                        style={{color: this.state.filters.length == 0 ? "#DDD" : "rgb(62, 121, 247)"}}/>
                    </Button>
                </Dropdown>
            </div>
        )
    }

}

function AclButton({aclType,row,onChange})
{
    const modal=useRef(null)


    return (
        <Fragment>
            <Button
                icon={<KeyOutlined/>}
                onClick={()=>{
                    modal.current.show(row.id,aclType,row)
                }}
            />

            <ModalAcl getRef={(ref)=>modal.current=ref} onFinish={()=>onChange()}/>
        </Fragment>
    )

}



const mapStateToProps = (state) => {
    return {
        org: state.auth.org,
        access: state.auth.access,
    }
};

export default connect(mapStateToProps)(React.memo(ResponsiveTable));
